module.exports = __webpack_public_path__ + "img/landing_box43.cbe9db48.jpg";